import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, onChange, max = 5, testId = "star-rating" }) {
  const [hover, setHover] = React.useState(0);
  const labels = ["Needs Improvement", "Average", "Good", "Very Good", "Excellent"];
  return (
    <div data-testid={testId} className="flex flex-col items-start gap-3">
      <div className="flex items-center gap-2">
        {Array.from({ length: max }).map((_, i) => {
          const idx = i + 1;
          const active = (hover || value) >= idx;
          return (
            <button
              type="button"
              key={idx}
              data-testid={`${testId}-star-${idx}`}
              onMouseEnter={() => setHover(idx)}
              onMouseLeave={() => setHover(0)}
              onClick={() => onChange?.(idx)}
              className={`p-1 rounded-md transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-saffron-500/30`}
              aria-label={`Rate ${idx} of ${max}`}
            >
              <Star
                className={`w-9 h-9 transition-colors ${active ? "fill-saffron-500 text-saffron-500" : "fill-transparent text-stone-300"}`}
                strokeWidth={1.5}
              />
            </button>
          );
        })}
      </div>
      <div className="text-sm text-stone-600 h-5">
        {value ? `${value} Star${value > 1 ? "s" : ""} — ${labels[value - 1]}` : "Tap to rate"}
      </div>
    </div>
  );
}
